module.exports = __webpack_public_path__ + "static/img/power.0e1b6cf6.png";